import React, {Component} from 'react';
import Form from '../components/Form';
import Header from '../components/Header';
import cookie from 'react-cookies';

class EventsCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      event: {}
    };
  }

  componentDidMount() {
    let cookies = cookie.loadAll();

    if(!cookies.tokenId){
        window.location.replace("https://auth.goaltiming.be/login?client_id=1n014khs8r0ghlvuvg7vds0tbg&response_type=token&scope=email%20openid&redirect_uri=https%3A%2F%2Fadmin.goaltiming.be%2Fview&fbclid=IwAR02CuBWOwLypoSCXUZ_MPuHVGTK7KUyg2cmEOA1JDsrUZgM8KnM36PV6gA");
    }else{
      const [header, payload, signature] = cookies.tokenId.split('.');
      const decodedPayload = JSON.parse(atob(payload));
      if(decodedPayload.email == 'revendeur.goaltiming@gmail.com'){
        window.location.replace("/resellers/view");
      }
        fetch("https://api.goaltiming.be/events/" + this.props.match.params.id + '/admin/',{
          headers: new Headers({
            'Authorization': cookies.tokenId
          }), 
        })
        .then(res => res.json())
        .then(
            (result) => {
              
            if(JSON.stringify(result.rankings) === JSON.stringify({})){
              result.rankings = [];
            }
            this.setState({
                isLoaded: true,
                event: result
            });
            },(error) => {
            this.setState({
                isLoaded: true,
                error
            });
            }
        )
    }
  }

  render() {
    const { error, isLoaded } = this.state;

    if (error) {
      return <div>Erreur : {error.message}</div>;
    } else if (!isLoaded) {
      return <div className="loader">Loading...</div>;
    } else {
      return (

        <div>
            {/* [ Header ] start */}
                <Header />
            {/* [ Header ] end */}

            {/* [ Main Content ] start */}
            <div className="pcoded-main-container">
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            {/* [ breadcrumb ] start */}
                            <div className="page-header">
                                <div className="page-block">
                                    <div className="row align-items-center">
                                        <div className="col-md-12">
                                            <div className="page-header-title">
                                                <h5 className="m-b-10">Goal Timing - Les évènements : Editer un évènement</h5>
                                            </div>
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item"><a href="/view"><i className="feather icon-home"></i></a></li>
                                                <li className="breadcrumb-item"><a href="/events/">Events</a></li>
                                                <li className="breadcrumb-item"><a href={"/events/edit/" + this.props.match.params.id}>Edit Events</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* [ breadcrumb ] end */}
                            <Form dataevent={this.state.event} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
      );
    }
  }
}

export default EventsCreate